// UrlConfigService: determine API / SSO endpoints based on hostname or env overrides
const getHostname = () => (typeof window !== 'undefined' && window.location && window.location.hostname) ? window.location.hostname.toLowerCase() : '';

export function isEdiHost() {
  return getHostname().includes('edi');
}

export function isPartnerHost() {
  return getHostname().includes('partner');
}

export function getBaseApiUrl() {
  // Environment-level overrides (preferred)
  const envDefault = process.env.REACT_APP_API_URL || '';
  const envEdi = process.env.REACT_APP_API_URL_EDI || '';
  const envPartner = process.env.REACT_APP_API_URL_PARTNER || '';

  if (isEdiHost() && envEdi) return envEdi;
  if (isPartnerHost() && envPartner) return envPartner;
  return envDefault;
}

export function getSsoStartPath() {
  // Default SSO start path used by the front-end to redirect to backend SSO
  return '/authenticate/admin/edi';
}

export default {
  isEdiHost,
  isPartnerHost,
  getBaseApiUrl,
  getSsoStartPath
};
